/* tslint:disable */
import React, { Component, ReactNode } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayout from "./layouts/Main";
import Index from "./views";
import Buildups from "./views/buildups";
import RevitAlert from "./components/RevitAlert";

interface IProps {
  setOnlineStatus: () => void;
  setOfflineStatus: () => void;
  showMaterialModal: () => void;
}

class App extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public componentWillMount() {
    (window as any).RevitAlert = () => {      
      this.props.showMaterialModal();
    }
    (window as any).BuildupCreated = () => {
      toast.success("Buildup created!");
    }
    (window as any).BuildupExists = (modelNumber: string) => {
      toast.error(<RevitAlert modelNumber={modelNumber}/>, {autoClose: 15000});
    }

    window.addEventListener("online", this.props.setOnlineStatus);
    window.addEventListener("offline", this.props.setOfflineStatus);
  }

  public componentWillUnMount() {
    window.removeEventListener("online", this.props.setOnlineStatus);
    window.removeEventListener("offline", this.props.setOfflineStatus);
  }

  public renderIndexPage() {
    return <Index />;
  }

  public renderBuildupPage() {
    return <Buildups />;
  }

  public render(): ReactNode {
    return (
      <Router>
        <MainLayout>
          <ToastContainer />
          <Switch>
            <Route path="/" render={this.renderBuildupPage} />
          </Switch>
        </MainLayout>
      </Router>
    );
  }
}

export default App;
